import React from "react";
import { Typography } from "@mui/material";
import { getPreparationSourceAuthors, formatPreparationCitation } from "./preparationSourceAuthors";

const PreparationSourceAttribution = ({
  sourceIds = [],
  evidence = [],
  authors = null,
}) => {
  const resolved = authors || getPreparationSourceAuthors(sourceIds, evidence);
  if (!resolved.length) return null;
  return (
    <Typography
      sx={{
        mt: 0.5,
        fontSize: "0.78rem",
        color: "text.secondary",
        overflowWrap: "anywhere",
      }}
    >
      {`Sources: ${resolved.map(formatPreparationCitation).join(", ")}`}
    </Typography>
  );
};
export default PreparationSourceAttribution;
